import React from 'react'
import {objectLang, setLocalStorageItem,} from "../functions"
import {GoogleLoginButton} from "../GoogleLoginButton"
import {YandexLoginButton} from "../YandexLoginButton"
import {MailLoginButton} from "../MailLoginButton"
import {EnterDataButton} from "../EnterDataButton"

export const AuthPageSocial = () => {
    setLocalStorageItem('page', 'AuthPageSocial')

    let widthWinSocial = '600px'
    if (window.matchMedia('(max-width: 768px)').matches) {
        widthWinSocial = window.innerWidth
    }

    const lang = objectLang().language

    return (
        <>
            <div className={'pt-3 d-flex flex-wrap justify-content-center'}>
                <div className={'d-flex w-100 justify-content-center'}>
                    <h1 className={'mb-4 text-center fw-bold'}>{lang.body.authPage.title}</h1>
                </div>
                <div id={'buttons-social'} style={{width: widthWinSocial}}>
                    <div
                        className={'social mt-1 m-3 mb-3 pt-0 p-3 border border-dark-subtle border-opacity-25 rounded-3'}>
                        <EnterDataButton disabled={false} isRegistration={false} isLogin={true}/>
                        <GoogleLoginButton disabled={false} isRegistration={false} isLogin={true}/>
                        {/*<FacebookLoginButton disabled={true} isRegistration={false} isLogin={true}/>*/}
                        <YandexLoginButton disabled={true} isRegistration={false} isLogin={true}/>
                        <MailLoginButton disabled={true} isRegistration={false} isLogin={true}/>
                    </div>
                </div>
            </div>
        </>
    )
}
